import { Box, Flex, Image } from '@everlywell/ui-kit';
import React from 'react';
import { IContentWithImage } from 'utils/types';

interface LogoGridProps {
  listOfContentWithImages: IContentWithImage[];
  maxWidth?: string;
  spacing?: number;
}

const LogoGrid: React.FC<LogoGridProps> = ({
  listOfContentWithImages,
  maxWidth = '1440px',
  spacing = 20,
}) => (
  <Box maxWidth={maxWidth} mx="auto" px={4} py={8}>
    <Flex
      flexWrap="wrap"
      gap={[spacing / 2, spacing]}
      alignItems="center"
      justifyContent="center"
      width="fit-content"
      mx="auto"
    >
      {listOfContentWithImages.map((contentWithImage, index) => (
        <Box key={index} width={{ base: '45%', md: '22%' }}>
          {contentWithImage.image && (
            <Image
              src={contentWithImage.image.url}
              alt={contentWithImage.image.title || ''}
              maxH="60px"
              objectFit="contain"
            />
          )}
        </Box>
      ))}
    </Flex>
  </Box>
);

export default LogoGrid;
